export default {
    charity: null,
    charities: null,
    selectedCharity: null
}



// WEBPACK FOOTER //
// ./src/store/charities/state.js